import { initReactI18next } from 'react-i18next';

import { de, enUS, es, fr, it } from 'date-fns/locale';
import i18n, { use as i18nextUse, init } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationDE from '../i18n/locales/de/translation.json';
import translationEN from '../i18n/locales/en/translation.json';
import translationES from '../i18n/locales/es/translation.json';
import translationFR from '../i18n/locales/fr/translation.json';
import translationIT from '../i18n/locales/it/translation.json';

const locales = {
    en: enUS,
    fr,
    de,
    es,
    it,
};

const resources = {
    en: {
        translation: translationEN,
    },
    fr: {
        translation: translationFR,
    },
    de: {
        translation: translationDE,
    },
    es: {
        translation: translationES,
    },
    it: {
        translation: translationIT,
    },
};

function init18n() {
    i18nextUse(initReactI18next);
    i18nextUse(LanguageDetector);
    init({
        detection: {
            order: ['querystring', 'localStorage', 'navigator'],
            lookupLocalStorage: 'spacefillLocale',
            lookupQuerystring: 'lang', // use ?lang=fr in url to switch language
        },
        resources,
        whitelist: ['fr', 'en', 'de', 'es', 'it'],
        cleanCode: true,
        nonExplicitWhitelist: true,
        fallbackLng: 'en',
        keySeparator: '|',
        nsSeparator: false,
        interpolation: {
            escapeValue: false,
        },
        useSuspense: false,
        compatibilityJSON: 'v3',
    });
}

const isIsoDateTime = (s) => {
    if (typeof s !== 'string') return false;
    const re = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+\\-]\d{2}:\d{2})$/;
    if (!re.test(s)) return false;
    const d = new Date(s);
    return !Number.isNaN(d.getTime());
};

const getDateFnsCurrentLocale = (locale) => locales[locale?.toLowerCase() ?? i18n.language.toLowerCase()];

export { init18n, getDateFnsCurrentLocale, isIsoDateTime };
